import { useUserName } from '../../contexts/userName';
import './styles.scss';

function WelcomeUser({ schoolsList, action = null }) {
  const { userName } = useUserName();

  function shortenedUserName() {
    return userName.split(' ')[0];
  }

  return (
    <div className={`welcome${action ? ' welcome--with-action' : ''}`}>
      {/* <img className="welcome__user-img" src={userImg}/> */}
      <div className='welcome__copy'>
        <span className='welcome__text'>¡Hola {shortenedUserName()}!</span>
        {schoolsList && (
          <span className='welcome__schools'>
            Estos son tus Procesos Formativos
          </span>
        )}
      </div>
      {action && <div className='welcome__action'>{action}</div>}
    </div>
  );
}

export default WelcomeUser;
